import { NavLink } from "react-router-dom";
import styles from "./SidebarNavItem.module.scss";
import { FC } from "react";
import clsx from "clsx";
import ArrowIcon from "@/shared/assets/arrowIcon.svg";
import { SidebarItemsType } from "@/widgets/sidebar/Sidebar";

interface SidebarNavItemProps {
  item: SidebarItemsType;
  parentIds: string[];
  childElementsToggler?: (id: string) => void;
  isSidebarSmall: boolean;
}

const SidebarNavItem: FC<SidebarNavItemProps> = ({
  item,
  childElementsToggler,
  parentIds,
  isSidebarSmall,
}) => {
  const { href, name, iconComponent, parentId, id } = item;
  const navLinkCssClasses = ({ isActive }: { isActive: boolean }): string => {
    return `${styles.navLink} ${isActive ? styles.active : ""}`;
  };
  const handleClick = () => childElementsToggler(id);
  if (parentId && !parentIds.includes(parentId)) {
    return <></>;
  }
  return (
    <div className={styles.linkItem}>
      {href ? (
        <NavLink className={navLinkCssClasses} to={href}>
          {iconComponent ||
            (isSidebarSmall && <span className={styles.noIconText}>▪▪▪</span>)}
          <span
            className={clsx(styles.text, { [styles.hide]: isSidebarSmall })}
          >
            {name}
          </span>
        </NavLink>
      ) : (
        <div
          className={clsx(styles.navLink, styles.noLink)}
          onClick={handleClick}
        >
          <div>
            {iconComponent}
            <span
              className={clsx(styles.text, { [styles.hide]: isSidebarSmall })}
            >
              {name}
            </span>
          </div>
          <div
            className={clsx(styles.arrow, {
              [styles.arrowDown]: parentIds.includes(id),
              [styles.hide]: isSidebarSmall,
            })}
          >
            {parentIds.includes(parentId) && <span>^</span>}
            <ArrowIcon width={17} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarNavItem;
